<template>
  <div
    class="MultiText form-group"
    :class="[
        divClasses,
      { 'has-danger': error },
      { 'has-danger': isError },
      { 'has-success': !error && touched },
      { 'has-success': isValid },
    ]"
  >
    <RecipeInsert @InsertRecipe="InsertRecipe" :selectClasses="RecipeInsertClasses"></RecipeInsert>
    <label>{{ label }}</label>
    <fg-input type="text" :placeholder="placeholder" v-model:value="InputText" addonRightIcon="FA-plus" :addonRightIconClick="AddText"></fg-input>
    <div class="row">
      <div v-for="(Input, k) in Inputs" :key="'Input'+k" class="col-12 TextLine">
        <span class="btn btn-danger mr-4" @click="RemoveText(k)">
            <font-awesome-icon icon="trash-can" title="Delete" />
        </span>
        <span v-if="Input.indexOf('<a href') === -1"><label>{{ InputLabel(k) }}</label>{{ Input }}</span>
        <span v-else><label>{{ InputLabel(k) }}</label><span v-html="Input"></span></span>
      </div>
    </div>
  </div>
</template>
<script>
import RecipeInsert from '@/Modules/Health/Components/Recipe_Insert.vue';

export default {
  inheritAttrs: false,
  name: "Text Input",
  components: {
    RecipeInsert
  },
  props: {
    LabelText: String,
    Inputs: Array,
    InputsLabels: Array,
    name: String,
    isError: Boolean,
    isValid: Boolean,
    required: Boolean,
    label: String,
    placeholder: String,
    error: String,
    divClasses: String,
    labelClasses: String,
    inputClasses: String,
    RecipeInsertClasses: {
      type: String,
      default: 'col-6'
    },
    value: [String, Number],
    addonRightIcon: String,
    addonRightIconClick: {
      type: Function,
      default: () => {}
    },
    addonLeftIcon: String,
  },
  data() {
    return {
      touched: false,
      focused: false,
      errorMessage: '',
      InputText: ''
    };
  },
  methods: {
    AddText() {
      if (!this.InputText.length) { return false; }
      let Inputs = [...this.Inputs];
      Inputs.push(this.InputText);
      let InputsLabels = [...this.InputsLabels];
      InputsLabels.push(this.LabelText);
      this.$emit('TextModified', {Labels: InputsLabels, Values: Inputs});
      this.InputText = '';
    },
    InputLabel(k) {
      let Label = '';
      if (typeof this.InputsLabels[k] !== 'undefined')
      { Label = this.InputsLabels[k]; }
      return Label;
    },
    RemoveText(index) {
      let Inputs = [...this.Inputs];
      Inputs.splice(index, 1);
      let InputsLabels = [...this.InputsLabels];
      InputsLabels.splice(index, 1);
      this.$emit('TextModified', {Labels: InputsLabels, Values: Inputs});
    },
    InsertRecipe(Link) {
      this.InputText += Link;
    }
  },
};
</script>
<style lang="scss">
.MultiText {
  .TextLine {
    label { margin-right: 10px; min-width: 120px; text-align: right; font-weight: bold; }
  }
}
</style>
